export const LOGIN = "admin/login";
export const PASSWORD_FORGET = "admin/forgot-password";
export const RESET_PASSWORD = "admin/reset-password";
export const EDIT_USER = "api/profileEdit";
export const FETCH_PROFILE = "api";
//Users
export const GET_CANDIDATE_WITH_FILTER = "api/candidates";
export const DELETE_CANDIDATE = "api/candidates/:id";
export const BULK_DELETE_CANDIDATE = "api/candidates/:id";
export const UPDATE_CANDIDATE_STATUS = "api/candidates/:id";









export const GET_CATEGORY_WITH_FILTER = "api/categories";
export const GET_CATEGORY_WITH_PAGE = "api/categories/pages";
export const DELETE_CATEGORY = "api/categories";
export const GET_CATEGORY_ID="api/categories";
export const CREATE_CATEGORY= "api/categories";
export const BULK_DELETE_CATEGORY = "api/categories";
export const UPDATE_CATEGORY_STATUS = "api/categories";








export const GET_QUESTION_PAGE="api/question/page"
export const GET_QUESTION_WITH_FILTER = "api/question";
export const DELETE_QUESTION = "api/question";
export const GET_QUESTION_ID="api/question";
export const CREATE_QUESTION= "api/question";
export const BULK_DELETE_QUESTION= "api/question";
export const UPDATE_QUESTION = "api/question";






export const GET_QUIZE_WITH_FILTER = "api/demodata/getQuize";
export const GET_QUIZE_WITH_PAGE="api/demodata/getQuize/pages"
export const DELETE_QUIZE = "api/quizeData";
export const GET_QUIZE_ID = "api/quizeData";
export const CREATE_QUIZE = "api/quizeData";
export const UPDATE_QUIZE = "api/quizeData";


export const DELETE_CANDIDATE_RESULT = "/api/testResult";
export const BULK_DELETE_CANDIDATE_RESULT = "api/testResult";
export const GET_CANDIDATE_TEST_RESULT_PAGE = "api/testResult/page";
export const GET_CANDIDATE_RESULT_ID = "api/testResult";
export const CREATE_CANDIDATE_RESULT = "api/testResult";
export const GET_CANDIDATE_TEST_WITH_FILTER="api/testResult"

export const GENERATE_RANDOM="api/generate";


export const DELETE_SETTING_RESULT = "api/setting"; // DELETE request
// export const BULK_DELETE_SETTING_RESULT = "api/testResult"; // Bulk DELETE request
export const GET_SETTING_RESULT_WITH_FILTER = "api/get/setting"; // GET request with filter
export const GET_SETTING_RESULT_ID = "api/setting"; // GET request by ID
export const CREATE_SETTING_RESULT = "api/setting"; // CREATE request
export const UPDATE_SETTING_RESULT = "/api/setting"; // UPDATE request